// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  dbDumpRequest: null,
  dbDumpSuccess: null,
  dbDumpFailure: ['err']
})

export const DbTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  err: null
})

/* ------------- Reducers ------------- */
export const request = (state: Object) => state.merge({
  fetching: true,
  err: null 
})

export const success = (state: Object) => state.merge({
  fetching: false,
  err: null
})

export const failure = (state: Object, { err }: Object) => state.merge({
  fetching: false,
  err
})

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.DB_DUMP_SUCCESS]: success,
  [Types.DB_DUMP_REQUEST]: request,
  [Types.DB_DUMP_FAILURE]: failure
})



// WEBPACK FOOTER //
// ./src/Redux/DbRedux.js